// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"3abff638","239":"e39fb35b","455":"492e6b75","484":"14cb0921","551":"8912905c","842":"01821987","977":"1fa8c7fd"}[chunkId] + ".chunk.js";
};